import { ref } from 'vue';

export const useThemeOverrides = () => {
  const datatable = ref({
    noLeftPadding: {
      header: {
        padding: '0 0 1rem 0',
      },
    },
  });

  return { datatable };
};
